import { ImmerStateCreator } from './store.types';

type TShopState = {
   state: {
      gold: number;
   };
};

type TShopActions = {
   actions: {
      addGold: (incoming: number) => void;
      spendGold: (params: { spent: number }) => void;
   };
};

type TShopSlice = TShopState & TShopActions;
export type TNamedShopSlice = { shop: TShopSlice };

export const getShopInitialState = (): TShopState['state'] => {
   return {
      gold: 0,
   }
};

export const createShopSlice: ImmerStateCreator<TNamedShopSlice, TShopSlice> = (set) => ({
   /***************************
    * State
    ***************************/
   state: getShopInitialState(),

   /***************************
    * Actions
    ***************************/
   actions: {
      addGold: (incoming: number) => {
         return set((state) => {
            state.shop.state.gold = state.shop.state.gold + incoming;
         });
      },
      spendGold: (params: { spent: number }) => {
         return set((state) => {
            state.shop.state.gold = state.shop.state.gold - params.spent;
         });
      },
   },
});
